<router-outlet></router-outlet>

<!-- Signed-out screens (login, company signup, password reset) had no way to
     change language at all: the switcher lived only in the backoffice and
     portal shells, so the first thing an international visitor saw was locked
     to whatever the default happened to be. -->
<div class="public-lang">
	<app-lang-switcher [isFloating]="true"></app-lang-switcher>
</div>
